import { Link } from '@tanstack/react-router';
import { ArrowUpRight } from 'lucide-react';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { cn } from '@/lib/utils';
import { DRILL_DOWN_CHIP_CLASS, DRILL_DOWN_CHIP_ICON_CLASS } from '@/styles/drillDownChip';
import { formatDisplayDate } from '@/utils/date';
import type { MapOn } from '../constants/moTravel.constants';

const DAY_ROUTE_MAP_ON: MapOn = 'DAILY';
const VERIFY_CHIP_CLASS = cn(DRILL_DOWN_CHIP_CLASS, 'text-xs');

interface VerifyRouteLinkProps {
  userId: number;
  personName: string | null;
  date: string;
  className?: string | undefined;
}

export function VerifyRouteLink({ userId, personName, date, className }: VerifyRouteLinkProps) {
  const person = personName ?? 'this person';
  const displayDate = formatDisplayDate(date);

  return (
    <Tooltip>
      <TooltipTrigger
        render={
          <Link
            to="/geo-location/mo-travel-history/$userId"
            params={{ userId }}
            search={{ date, mapOn: DAY_ROUTE_MAP_ON }}
            target="_blank"
            rel="noreferrer"
          />
        }
        aria-label={`Verify ${person}'s route on ${displayDate}, opens in a new tab`}
        className={cn(VERIFY_CHIP_CLASS, className)}
      >
        Verify
        <ArrowUpRight className={DRILL_DOWN_CHIP_ICON_CLASS} aria-hidden />
      </TooltipTrigger>
      <TooltipContent>{`Open ${person}'s route on ${displayDate} in a new tab`}</TooltipContent>
    </Tooltip>
  );
}
